// extracted by mini-css-extract-plugin
export var csatScore = "_fi-5";
export var header = "_fi-1";
export var panelWrapper = "_fi-2";
export var postPreview = "_fi-3";
export var rightContent = "_fi-0";
export var wrappingText = "_fi-4";